import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/CampusFacilitiesPageComponents/Infrastructure/ExploreFacilities/ExploreFacilities.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Common/TopRecruiters/TopRecruiters.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Common/VideoPlayer/VideoPlayer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/TrainingPlacementPageComponents/AboutDepartment/AboutDepartment.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/TrainingPlacementPageComponents/DepartmentFaculty/DepartmentFaculty.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/TrainingPlacementPageComponents/HighlightsSection/HighlightsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/TrainingPlacementPageComponents/RecruitersSection/RecruitersSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/TrainingPlacementPageComponents/StickyBottomBar/StickyBottomBar.tsx");
